window.CEPAutoFillComponent={
    url: "https://viacep.com.br/ws/[CEP]/json/",
    parseUrl(cep){
        return CEPAutoFillComponent.url.replace(/\[CEP\]/g,CEPAutoFillComponent.parseCEP(cep));
    },
    parseCEP(cep){
        return cep.match(/[0-9]+/g).join('').toString();
    },
    get(cep){
        let self=CEPAutoFillComponent;
        return new Promise((res,rej) => {
            if(self.parseCEP(cep).length == 8){
                $.ajax({
                    method: "GET",
                    url: self.parseUrl(cep),
                    success(data){
                        if(data.erro) rej("Endereço não encontrado");
                        else res({
                            cep:         data.cep,
                            logradouro:  data.logradouro,
                            complemento: data.complemento,
                            bairro:      data.bairro,
                            cidade:      data.localidade,
                            uf:          data.uf
                        });
                    },
                    error(err){
                        rej(err.message);
                    }
                });
            }else{
                rej("CEP incompleto");
            }
        });
    }
};